"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonWrapupTrackerData = exports.mergeWrapupTrackerConfig = exports.fetchCommonTealiumTrackerDataV2 = exports.getCommonTealiumTrackerData = exports.fetchCommonTealiumTrackerData = exports.mergeDynatraceTrackerConfig = exports.mergeTealiumTrackerConfig = exports.mergeDomEventsTrackerConfig = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const ip_utility_1 = require("../utils/ip.utility");
const device_utility_1 = require("../utils/device.utility");
const contactCenter_1 = require("../contactCenter");
const mergeDomEventsTrackerConfig = (config, commonData) => {
    const newConfig = {
        domEventsTracker: {
            configData: {},
            getCommonDomEventsConfig: config.domEventsTracker?.getCommonDomEventsConfig,
            language: config.domEventsTracker?.language,
        },
    };
    for (const property in config.domEventsTracker?.configData) {
        if (config.domEventsTracker?.configData[property] instanceof Function) {
            newConfig.domEventsTracker.configData[property] = (...args) => {
                const a = config.domEventsTracker?.configData[property];
                return {
                    ...a(...args),
                    ...commonData,
                };
            };
        }
        else {
            newConfig.domEventsTracker.configData[property] = {
                ...config.domEventsTracker.configData[property],
                ...commonData,
            };
        }
    }
    return newConfig;
};
exports.mergeDomEventsTrackerConfig = mergeDomEventsTrackerConfig;
const mergeTealiumTrackerConfig = (config, commonData) => {
    const newConfig = {
        tealiumTracker: {
            configData: {},
            getCommonTealiumConfig: config.tealiumTracker?.getCommonTealiumConfig,
            language: config.tealiumTracker?.language,
        },
    };
    for (const property in config.tealiumTracker?.configData) {
        if (config.tealiumTracker?.configData[property] instanceof Function) {
            newConfig.tealiumTracker.configData[property] = (...args) => {
                const a = config.tealiumTracker?.configData[property];
                return {
                    ...a(...args),
                    ...commonData,
                };
            };
        }
        else {
            newConfig.tealiumTracker.configData[property] = {
                ...config.tealiumTracker.configData[property],
                ...commonData,
            };
        }
    }
    return newConfig;
};
exports.mergeTealiumTrackerConfig = mergeTealiumTrackerConfig;
const mergeDynatraceTrackerConfig = (config, commonData) => {
    const newConfig = {
        dynatraceTracker: {
            configData: {},
            getCommonDynatraceConfig: config.dynatraceTracker?.getCommonDynatraceConfig,
            reporterConfig: config.dynatraceTracker?.reporterConfig || {
                token: '',
                collectorUrl: '',
            },
        },
    };
    for (const property in config.dynatraceTracker?.configData) {
        if (config.dynatraceTracker?.configData[property] instanceof Function) {
            newConfig.dynatraceTracker.configData[property] = (...args) => {
                const a = config.dynatraceTracker?.configData[property];
                return {
                    ...a(...args),
                    ...commonData,
                };
            };
        }
        else {
            newConfig.dynatraceTracker.configData[property] = {
                ...config.dynatraceTracker.configData[property],
                ...commonData,
            };
        }
    }
    return newConfig;
};
exports.mergeDynatraceTrackerConfig = mergeDynatraceTrackerConfig;
const fetchCommonTealiumTrackerData = async (config, authenticator, API) => {
    // TODO: In Hybrid this should be returned by mobile device
    const isLoggedIn = authenticator?.getSession()?.isValid();
    const userTealiumTrackerData = await getUserTealiumTrackerData(isLoggedIn, API);
    const commonTealiumTrackerData = await (0, exports.getCommonTealiumTrackerData)(config, isLoggedIn);
    return { ...userTealiumTrackerData, ...commonTealiumTrackerData };
};
exports.fetchCommonTealiumTrackerData = fetchCommonTealiumTrackerData;
const getUserTealiumTrackerData = async (isLoggedIn, API) => {
    const commonDataTracker = {};
    const promises = [];
    if (isLoggedIn) {
        commonDataTracker.loginMethod = web_ui_framework_1.LoginMethod.PASSWORD;
        try {
            promises.push(API.GET(`${window.MIDDLEWARE_BASE_HOST}/mb-api-customers/v1/customers/id`));
            promises.push((0, ip_utility_1.fetchIp)(API));
            const response = await Promise.all(promises);
            commonDataTracker.userID = response[0]?.data?.response?.customerId;
            commonDataTracker.userIP = response[1];
        }
        catch (e) {
            console.error(e);
        }
    }
    return commonDataTracker;
};
const getCommonTealiumTrackerData = async (config, isLoggedIn = false) => {
    const commonDataTracker = {};
    const isOnboarding = config?.tealiumTracker?.webArea === web_ui_framework_1.WebArea.ONBOARDING;
    commonDataTracker.userType = isOnboarding ? web_ui_framework_1.UserType.PROSPECT : web_ui_framework_1.UserType.CLIENT;
    commonDataTracker.userMarket = window.COUNTRY;
    commonDataTracker.userStatus = isLoggedIn ? web_ui_framework_1.UserStatus.LOGGEDIN : web_ui_framework_1.UserStatus.LOGGEDOUT;
    commonDataTracker.webArea = isOnboarding ? web_ui_framework_1.WebArea.ONBOARDING : web_ui_framework_1.WebArea.PRIVATE;
    commonDataTracker.webLang = config?.tealiumTracker?.language;
    commonDataTracker.webVersion = (0, device_utility_1.getDeviceType)();
    return commonDataTracker;
};
exports.getCommonTealiumTrackerData = getCommonTealiumTrackerData;
const fetchCommonTealiumTrackerDataV2 = async (config, getMobileConnector, authenticator, API) => {
    const commonDataTracker = await (0, exports.fetchCommonTealiumTrackerData)(config, authenticator, API);
    if ((0, web_ui_framework_1.isWebViewPlatform)()) {
        try {
            const data = (await getMobileConnector().requestSessionTrackingInfo());
            const response = await JSON.parse(data);
            commonDataTracker.sessionStart = response.session_start;
            commonDataTracker.sessionRandom = response.session_id;
        }
        catch (e) {
            console.error('Cannot add sessionStart and sessionRandom to Tealium Tracker. Failed to communicate with native. Ensure that MobileCommuncator is initialized', e);
        }
    }
    return commonDataTracker;
};
exports.fetchCommonTealiumTrackerDataV2 = fetchCommonTealiumTrackerDataV2;
const mergeWrapupTrackerConfig = (config, commonData) => {
    const newConfig = {
        wrapupTracker: {
            configData: {},
            getCommonWrapupConfig: config.wrapupTracker?.getCommonWrapupConfig,
        },
    };
    for (const action in config.wrapupTracker?.configData) {
        if (typeof config.wrapupTracker?.configData[action] === 'function') {
            newConfig.wrapupTracker.configData[action] = (...args) => {
                const data = (config.wrapupTracker?.configData[action])(...args);
                data.sessionId = commonData.sessionId;
                if (data.obj) {
                    data.obj.navigationId = commonData.generateNavigationId();
                }
                return data;
            };
        }
        else {
            newConfig.wrapupTracker.configData[action] = {
                ...config.wrapupTracker?.configData[action],
                sessionId: commonData.sessionId,
                obj: {
                    ...(config.wrapupTracker?.configData[action]).obj,
                    navigationId: commonData.generateNavigationId(),
                },
            };
        }
    }
    return newConfig;
};
exports.mergeWrapupTrackerConfig = mergeWrapupTrackerConfig;
const getCommonWrapupTrackerData = (USDManager) => {
    if (!USDManager) {
        throw new Error('TrackerUSDManager not initialized');
    }
    return {
        sessionId: USDManager.getInformation().sessionId,
        generateNavigationId: contactCenter_1.createNavigationId,
    };
};
exports.getCommonWrapupTrackerData = getCommonWrapupTrackerData;
//# sourceMappingURL=tracker.utils.js.map